import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

export function useResponsive() {
  const breakpoints = useBreakpoints(breakpointsTailwind);
  const isDesktop = breakpoints.greaterOrEqual("lg");
  return { isDesktop };
}
